module.exports = __webpack_public_path__ + "img/area-comum-13.31aa88cb.png";